import classNames from "classnames";
import React from "react";
import { CHEVRON_DOWN_ICON } from "../utils/svgs_new";
import { AppCard, AppCardContent } from "./Generic/AppCard";
import { AppIcon } from "./Generic/AppIcon";
import SelectBottomSheet from "./Generic/SelectBottomSheet";
import QuestionHeader from "./QuestionHeader";
import RequiredDocReadonlyAnswer from "./RequiredDocReadonlyAnswer";
import { ReqDocAnswerableQuestionMulti } from "./ScheduledVisitDocScreen";

export interface SelectOption {
  key: string;
  value: any;
}

export interface SelectProps extends ReqDocAnswerableQuestionMulti {
  options: SelectOption[];
  selectedOption: SelectOption | null;
  isSelectBottomSheetOpen: boolean;
  placeholder: string;
  onOpenSelectBottomSheet: () => void;
  onCloseSelectBottomSheet: () => void;
  onChooseOption: (selectedOption: SelectOption) => void;
}

const RequiredDocDropDown = (props: SelectProps) => {
  return (
    <AppCard
      className={classNames({ __invalid: !props.isValid })}
      onClick={() => {
        if (props.readonly && props.onClickWhileDisabled !== undefined) {
          props.onClickWhileDisabled();
        }
      }}
    >
      <QuestionHeader
        text={props.questionText}
        isRequired={props.isRequired}
        notes={props.notes}
        isReadonly={props.readonly}
      />
      <AppCardContent>
        {props.readonly ? (
          <RequiredDocReadonlyAnswer currentAnswer={props.currentAnswer} />
        ) : (
          <div
            className="ScheduledVisitDocScreen_selectContainer"
            onClick={props.onOpenSelectBottomSheet}
          >
            {props.placeholder}
            <AppIcon
              icon={CHEVRON_DOWN_ICON}
              fill="var(--gray-600)"
              size={12}
              style={{ margin: "8px 6px 0px" }}
            />
          </div>
        )}
      </AppCardContent>
      <SelectBottomSheet
        isOpen={props.isSelectBottomSheetOpen}
        options={props.options}
        selectedOption={props.selectedOption}
        onCancel={props.onCloseSelectBottomSheet}
        onChoose={props.onChooseOption}
      />
    </AppCard>
  );
};

export default React.memo(RequiredDocDropDown);
